import {useState} from 'react'
import CustomBox from '../../../components/common/CustomBox'
import Alert from '@mui/material/Alert'
import IconButton from '@mui/material/IconButton'
import Collapse from '@mui/material/Collapse'
import CloseIcon from '@mui/icons-material/Close'
import {StyledAnchor} from './InfoNotificationComponentStyle'
import buttonTitles from '../../../appConfig/buttonTitles.config.json'
import PropTypes from 'prop-types'

const InfoNotificationComponent = ({fromUserManagement, setRenderUserView}) => {
  InfoNotificationComponent.propTypes = {
    fromUserManagement: PropTypes.bool,
    setRenderUserView: PropTypes.func
  }

  const [open, setOpen] = useState(true)

  const traverseProjectDetails = () => {
    setRenderUserView(false)
  }

  const projectDetailsLink = (
    <StyledAnchor
      href='#'
      aria-label='click-to-go-to-project-details'
      onClick={(event) => {
        event.preventDefault()
        traverseProjectDetails()
      }}
    >
      Project Details
    </StyledAnchor>
  )

  const alertText = (
    <>
      We’ll need all {fromUserManagement ? projectDetailsLink : 'project details'} completed before you can share this
      project with other users.
    </>
  )

  const ariaLabel = alertText.props.children.filter((child) => typeof child === 'string').join(' ')

  return (
    <CustomBox sx={{width: '100%'}}>
      <Collapse in={open}>
        <Alert
          tabIndex={0}
          severity='info'
          action={
            <IconButton
              title={buttonTitles.notificationTitle}
              data-testid='closeIcon'
              aria-label='close-alert'
              color='inherit'
              size='small'
              onClick={() => {
                setOpen(false)
              }}
            >
              <CloseIcon fontSize='inherit' />
            </IconButton>
          }
          sx={{mb: 2}}
          aria-label={ariaLabel}
          aria-live='off'
        >
          {alertText}
        </Alert>
      </Collapse>
    </CustomBox>
  )
}

export default InfoNotificationComponent
